import Vue from 'vue'
import { BootstrapVue, BootstrapVueIcons } from 'bootstrap-vue'
import 'bootstrap-vue/dist/bootstrap-vue-icons.min.css'

Vue.use(BootstrapVue)
Vue.use(BootstrapVueIcons)

// Vue Router
import router from './router'
// Vuex
import store from './store'
// Install Vue Router
import validate from './validate'
// VueAxios
import axios from "axios";
import VueAxios from "vue-axios";
// Loading...
import VueLoading from 'vue-loading-template'
Vue.use(VueAxios, axios, VueLoading);

import App from './App.vue'

Vue.config.productionTip = false
Vue.config.devtools = true;

// jQuery
import jQuery from 'jquery'
global.jquery = jQuery
global.$ = jQuery
window.$ = window.jQuery = require('jquery')

// bootstrap
import 'bootstrap'
import 'bootstrap/dist/css/bootstrap.css'

new Vue({
  el: '#app',
  data() {
    return {
      logo: require("./assets/default-logo.png"),
    };
  },
  axios,
  router,
  store,
  validate,
  VueLoading,
  render: h => h(App),
}).$mount('#app')
